import { useEffect, useState } from "react";
import type { DeliveryBatchPayment, DeliveryPaymentMethod } from "@mnp/shared";

const METHOD_LABELS: Record<DeliveryPaymentMethod, string> = {
  cash: "Нал",
  card: "Карта",
  transfer: "Перевод",
};

interface PaymentModalProps {
  open: boolean;
  amountGel: number;
  onClose: () => void;
  onSubmit: (payment: DeliveryBatchPayment) => void;
  loading?: boolean;
}

export function PaymentModal({ open, amountGel, onClose, onSubmit, loading = false }: PaymentModalProps) {
  const [method, setMethod] = useState<DeliveryPaymentMethod>("cash");
  const [amount, setAmount] = useState(String(amountGel));

  useEffect(() => {
    if (open) setAmount(String(amountGel));
  }, [amountGel, open]);

  if (!open) return null;

  const parsedAmount = Number(amount);
  const canSubmit = Number.isFinite(parsedAmount) && parsedAmount >= 0;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30" role="presentation">
      <form
        className="w-full max-w-md rounded-lg bg-white p-5 shadow-xl"
        aria-label="Оплата при выдаче"
        onSubmit={(event) => {
          event.preventDefault();
          if (canSubmit) onSubmit({ method, amountGel: parsedAmount });
        }}
      >
        <h2 className="text-lg font-semibold text-gray-900">Оплата при выдаче</h2>
        <div className="mt-4 grid grid-cols-3 gap-2">
          {Object.entries(METHOD_LABELS).map(([value, label]) => (
            <button
              key={value}
              type="button"
              onClick={() => setMethod(value as DeliveryPaymentMethod)}
              className={`rounded border px-3 py-2 text-sm ${
                method === value ? "border-mnp-stamp bg-mnp-stamp/10 text-mnp-stamp" : "border-gray-200 text-gray-700"
              }`}
            >
              {label}
            </button>
          ))}
        </div>
        <label className="mt-4 block text-sm font-medium text-gray-700">
          Сумма, GEL
          <input
            value={amount}
            onChange={(event) => setAmount(event.target.value)}
            inputMode="decimal"
            className="input-admin mt-1 w-full"
          />
        </label>
        <div className="mt-5 flex justify-end gap-2">
          <button type="button" onClick={onClose} className="btn-secondary" disabled={loading}>
            Отмена
          </button>
          <button type="submit" className="btn-primary" disabled={!canSubmit || loading}>
            {loading ? "…" : "Подтвердить"}
          </button>
        </div>
      </form>
    </div>
  );
}
